module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAt0lEQVQ4jd3RPWoCQQCA0bcasLDQzhPYCUIqKysRb+ABBH/IgQIWKXKElIJgYZMqla29NhbaihZZYQmbXTeZIuRrZoaBN8xMNNu913EQqFIo6P+A+5DgHA20sAwBLuJxgx5GOP0GPH9Zv6CN9U/BtLboYoJjCBAuPt93EAq8VQkFlvCEt7TNh4JYE6/oZJ32XeXEPMIUH1lYHtiPx0es8IxqFkb2lccYopaHJMv7lELYPWDh/j54BWLCFiZWfEFCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play.png
// module id = 537
// module chunks = 0